import { render } from "./innerHeaderDIY.vue?vue&type=template&id=558996b6&scoped=true"
import script from "./innerHeaderDIY.vue?vue&type=script&lang=js"
export * from "./innerHeaderDIY.vue?vue&type=script&lang=js"

import "./innerHeaderDIY.vue?vue&type=style&index=0&id=558996b6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558996b6"]])

export default __exports__